import { useContext } from 'react';
import { StyledFilter } from './Filters.style';
import MetricsInspectionContext from '../../state/context';
import FilterChip from 'views/root/views/home/views/settings/views/ProjectManagement/connected-components/PMConfiguration/components/PMEntities/components/FilterChip';
import { getEntityNameByActivityTypeAndTotal } from '../../state/state.utils';
import { onRemoveSelectedPointsFilter } from '../../state/actions';

const SelectedPoints = () => {
  const {
    state: {
      selectedPoints,
      filters: { activityType }
    },
    dispatch
  } = useContext(MetricsInspectionContext);

  const totalPoints = selectedPoints?.length;
  const isFilterExists = totalPoints > 0;

  if (!isFilterExists) return null;

  const entityName = getEntityNameByActivityTypeAndTotal(
    activityType,
    totalPoints
  );
  const text = `${selectedPoints.length} ${entityName} selected`;

  return (
    <StyledFilter>
      <FilterChip
        text={text}
        onClose={() => dispatch(onRemoveSelectedPointsFilter())}
      />
    </StyledFilter>
  );
};

export default SelectedPoints;
